export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 3600, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "https://consortadmin.kinsta.cloud/graphql", "connectToDevTools": true, "tokenName": "apollo:favorites.token", "defaultOptions": {"query": {"errorPolicy": "all"}}, "authType": "Bearer", "authHeader": "Authorization", "tokenStorage": "cookie"}}
}